import { t } from 'i18next';

import { ErrorResponseErrorItemCodeComment } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeComment, string> => ({
  'comment:not_found': t('comment.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Kommentaren existerar inte.',
  }),
  'comment:user_unauthorized': t('comment.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till aktuell kommentar.',
  }),
});
